export interface ShiftEmployee {
  id: number;
  name: string;
}

export interface ShiftFormEmployee {
  user_id: number;
  name: string;
  on_this_shift: boolean;
  current_shift_id: number | null;
  current_shift_name: string | null;
}

export interface ShiftEmployeesResponse {
  success: boolean;
  shift_id: number;
  employees: ShiftFormEmployee[];
}

export interface Shift {
  id: number;
  company_id: number;
  shift_name: string;
  timezone: string;
  start_time: string;
  end_time: string;
  is_overnight: boolean;
  working_days: number[];
  buffer_start_minutes?: number;
  buffer_end_minutes?: number;
  strict_window?: boolean;
  status?: 'active' | 'inactive';
  is_active?: boolean;
  employee_ids?: number[];
  employee_count?: number;
  employees?: ShiftEmployee[];
  created_at?: string;
  updated_at?: string;
}

export interface ShiftPayload {
  shift_name: string;
  timezone: string;
  shift_start_time: string;
  shift_end_time: string;
  working_days: number[];
  is_overnight: boolean;
  buffer_start_minutes?: number;
  buffer_end_minutes?: number;
  strict_window?: boolean;
  employee_ids?: number[];
}

export const WORKING_DAYS = [
  { label: 'Mon', value: 1 },
  { label: 'Tue', value: 2 },
  { label: 'Wed', value: 3 },
  { label: 'Thu', value: 4 },
  { label: 'Fri', value: 5 },
  { label: 'Sat', value: 6 },
  { label: 'Sun', value: 7 },
];

export interface TimezoneOption {
  value: string;
  label: string;
  offset: string;
}

export interface TimezoneResponse {
  success: boolean;
  timezones: TimezoneOption[];
  generated_at_utc: string;
}
